import { useQuery } from '@tanstack/react-query';
import { actions } from 'api/actions';
import { endpoints } from 'api/endpoints';
import { useEffect } from 'react';
import { useSequentialTasks } from '@wix/gg-common-lib/hooks';

type Props = {
  onError: (error: Error) => void;
};

export const useStoreSetup = ({ onError }: Props) => {
  const { runTasks } = useSequentialTasks([
    [
      { task: actions.attachSiteTemplate },
      {
        task: async () => {
          await endpoints.resetStore({});
        },
        retries: 10,
      },
      { task: actions.uploadSiteMedia },
    ],
    [{ task: actions.addStoreProducts }, { task: actions.updateSiteName }, { task: actions.injectSiteNameComponent }],
    {
      task: async () => {
        await endpoints.publishSite();
      },
    },
    [
      { task: actions.validateCatalogProductsCount, retries: 20 },
      { task: actions.fetchSiteUrl, retries: 10 },
    ],
  ]);

  const { isSuccess, isError, refetch, error } = useQuery({
    queryKey: ['store-setup'],
    queryFn: async () => {
      await runTasks();
      return {};
    },
  });

  useEffect(() => {
    if (error && isError) {
      onError(error);
    }
  }, [error, isError, onError]);

  return { isSuccess, isError, refetch };
};
